<template lang="pug">
  #airtrip-tooltip
    AppIconButton(
      title="company_system.rate_plan_settings.rate_plan.details.car_class_settings.airtrip_warning"
      icon="exclamationCircle"
      :use-app-icon="true"
    )
    BTooltip(
      custom-class="airtrip-tooltip-body"
      target="airtrip-tooltip"
      placement="right"
      triggers="click blur"
    )
      img(:src="imageUrl")
</template>

<script>
  const AIRTRIP_WARNING_IMAGE = "/airtrip-warning.png"

  export default {
    components: {
      AppIconButton: () => import("@/components/elements/AppButton/WithIcon/Other")
    },

    data() {
      return {
        imageUrl: AIRTRIP_WARNING_IMAGE
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/variables.sass"

  #airtrip-tooltip
    button
      height: 24px
      border: none
      color: $default-purple
      padding: 0 8px !important

      &:hover
        border: none
        box-shadow: none

        ::v-deep
          .title
            color: $default-gray
          svg
            path
              fill: $default-gray
      ::v-deep
        svg
          path
            fill: $default-purple

  .airtrip-tooltip-body
    opacity: 1

    ::v-deep
      .arrow
        &::before
          border-right-color: $default-purple
          border-left-color: $default-purple
      .tooltip-inner
        padding: 0
        min-width: 600px
        height: 450px
</style>
